import React from 'react';
import { Observe } from 'rewire-core';
import { WithStyle } from 'rewire-ui';
import { Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '../ui/Grid';
import Loader from '../ui/Loader';
import { DailyRollupModelBase } from './DailyRollupModel';
import { defaultFontSizes } from './TimecardGrids';
import { withStyles } from '../utility/styles';

const styles = (theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '8px',
  },
  separationBorder: {
    borderBottom: 'solid 1px lightgray',
  },
  noResults: {
    fontStyle: 'italic',
    margin: '10px',
  },
  grid: {
    '& tbody tr:hover': {
      backgroundColor: '#e0e9f0',
    },
    '& tr th div': {
      color: 'white',
      fontStyle: 'normal',
    },
    '& td.readOnly': {
      color: '#4f778a',
    },
    '& td.future': {
      fontStyle: 'italic',
      color: theme.palette.text.disabled,
    },
    '& th': {
      whiteSpace: 'pre-wrap',
      paddingTop: '3px',
      paddingBottom: '3px',
    },
    '& tr.totalRow > td': {
      color: '#14809d',
      fontSize: '12px',
    },
    '& tr.reversal>td': {
      fontStyle: 'italic',
      textDecoration: 'line-through',
      color: theme.palette.error.main,
    },
  },
});

interface IDailyRollupProps {
  model: DailyRollupModelBase;
}

type DailyRollupProps = WithStyle<ReturnType<typeof styles>, IDailyRollupProps>;

class DailyRollupView extends React.PureComponent<DailyRollupProps> {
  constructor(props: DailyRollupProps) {
    super(props);
  }

  componentWillUnmount() {
    this.props.model.reset();
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Observe
          render={() => (
            <Loader loading={this.props.model.isLoading} showWhileLoading={true}>
              <Observe
                render={() => (
                  <Grid
                    key={this.props.model.grid.id}
                    grid={this.props.model.grid}
                    gridFontSizes={defaultFontSizes}
                    className={classes.grid}
                  />
                )}
              />
            </Loader>
          )}
        />

        <Observe
          render={() => (
            <div className={this.props.model.selectedEmployee ? undefined : classes.separationBorder}>
              {!this.props.model.selectedEmployee ? (
                <Typography className={this.props.classes.noResults} variant="subtitle1">
                  No employee selected
                </Typography>
              ) : null}
            </div>
          )}
        />
      </div>
    );
  }
}

export default withStyles<IDailyRollupProps>(styles, DailyRollupView);
